<sui-dialog-header class="header" (closeButtonClick)="onCloseButtonClick()">
  <p>독서기록을 보고 싶은 그룹책 멤버를 선택하세요.</p>
</sui-dialog-header>

<div class="body">
  <!-- 로딩 상태 -->
  <div class="loading" *ngIf="_isLoading">
    <sui-loader></sui-loader>
  </div>

  <!-- 멤버가 없을 때 -->
  <div
    class="no-member"
    *ngIf="!_isLoading && (!_members || _members.length === 0)"
  >
    <p class="no-member-text">이 그룹책을 함께읽는 멤버가 없습니다</p>
  </div>

  <!-- 멤버 목록 -->
  <div
    class="list"
    #listElem
    *ngIf="!_isLoading && _members && _members.length > 0"
  >
    <div
      class="list-item"
      *ngFor="let member of _members"
      [class.is-selected]="_selectedMemberId === member.id"
    >
      <div class="member">
        <sui-reading-group-member
          [member]="member"
          [isOnline]="member.isOnline || !!member.is_me"
          [class.is-clickable]="!member.is_me"
          (click)="!member.is_me && _onClickAvatar(member)"
        ></sui-reading-group-member>
        <sui-rounded-tag *ngIf="member.is_owner">만든이</sui-rounded-tag>
      </div>
      <div
        class="member-actions"
        [class.is-hidden]="
          member.is_me || member.is_blocked || !_isSelectionMode
        "
      >
        <button
          class="selection-button"
          (click)="_onSelectMember(member)"
          [class.is-hidden]="_selectedMemberId === member.id"
        >
          선택하기
        </button>
      </div>
    </div>
  </div>
</div>
